module.exports = __webpack_public_path__ + "static/media/como-37.a4d586a9.jpg";